/** Protokoll: Audit/Bewegungen (Paket 1), Sync/Outbox/Postausgang/Webhooks (Paket 2), Einstellungen. */
import { api, post } from '../api';
import { liste, put, qs } from './http';
import type {
  AuditZeile, BewegungZeile, Einstellungen, EinstellungenAenderung, IntegrationenStatus, MailLogZeile, OutboxZeile, SyncLogZeile, WebhookZeile,
} from './typen';

export const audit = (f: { q?: string; entitaet?: string } = {}) => liste<AuditZeile>(`/protokoll/audit${qs(f)}`);
export const bewegungen = (f: { q?: string } = {}) => liste<BewegungZeile>(`/protokoll/bewegungen${qs(f)}`);
export const syncLog = (f: { ergebnis?: string } = {}) => liste<SyncLogZeile>(`/sync-log${qs({ ...f, limit: 200 })}`);
export const outbox = (f: { status?: string; typ?: string } = {}) => liste<OutboxZeile>(`/outbox${qs({ ...f, limit: 200 })}`);
export const outboxErneut = (id: string) => post<{ ok: boolean }>(`/outbox/${id}/erneut`, {});
export const postausgang = () => liste<MailLogZeile>(`/postausgang${qs({ limit: 200 })}`);
export const webhookInbox = () => liste<WebhookZeile>(`/webhook-inbox${qs({ limit: 200 })}`);
export const integrationenStatus = () => api<IntegrationenStatus>('/integrationen/status');
export const einstellungen = () => api<Einstellungen>('/einstellungen');
/** Admin. */
export const einstellungenAendern = (d: EinstellungenAenderung) => put<Einstellungen>('/einstellungen', d);
